var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    viewBox: "0 0 25 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.3333C19.4036 8.3333 25 6.46783 25 4.16665C25 1.86547 19.4036 0 12.5 0C5.59644 0 0 1.86547 0 4.16665C0 6.46783 5.59644 8.3333 12.5 8.3333Z",
    fill: "#D3B36E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.3333C19.4036 8.3333 25 6.46783 25 4.16665C25 1.86547 19.4036 0 12.5 0C5.59644 0 0 1.86547 0 4.16665C0 6.46783 5.59644 8.3333 12.5 8.3333Z",
    fill: "#D3B36E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1294 9.48467C19.5202 10.3543 16.1005 10.8333 12.5 10.8333C8.89951 10.8333 5.47974 10.3543 2.87061 9.48467C1.67656 9.08667 0.73667 8.63433 0 8.15449V9.91665C0 11.0296 1.30015 12.076 3.66118 12.8629C6.02207 13.6499 9.16108 14.0833 12.5 14.0833C15.8389 14.0833 18.9779 13.65 21.3388 12.8629C23.6998 12.076 25 11.0296 25 9.91665V8.15449C24.2633 8.63433 23.3234 9.08657 22.1294 9.48467Z",
    fill: "#D3B36E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1294 15.2347C19.5203 16.1043 16.1005 16.5833 12.5 16.5833C8.89951 16.5833 5.47969 16.1043 2.87061 15.2346C1.67651 14.8366 0.736621 14.3844 0 13.9045V15.8334C0 18.1345 5.59644 20 12.5 20C19.4036 20 25 18.1345 25 15.8333V13.9046C24.2634 14.3843 23.3235 14.8367 22.1294 15.2347Z",
    fill: "#D3B36E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMines);
export default __webpack_public_path__ + "static/media/mines.f2a63ad646c57cae8e9f83f6560e2442.svg";
export { ForwardRef as ReactComponent };